module.exports = __webpack_public_path__ + "img/Skirt-Back-B2-Da-Gb-Ha-Ia.7a12aaa4.png";